import React from 'react';
import SearchBarBtn from '../../assets/icons/searchBarBtn.svg';
// import SearchIcon from '../../assets/icons/searchIcon.svg';
import { useTheme } from '../../middleware/ThemeContext';
import SearchIcon from '../../assets/icons/SearchIcon';
import { Spinner } from 'react-bootstrap';
import { LoadingSpinner } from '../../features/ui/LoadingSpinner';

interface SearchBarProps {
    className?: string;
    style?: React.CSSProperties;
    onSearchChange?: (value: string) => void;
    onButtonClick?: () => void;
    searchTerm?: string;
    placeholder?: string;
    showLoader?: boolean;
    disabled?: boolean;
}

const SearchBar: React.FC<SearchBarProps> = ({
    className,
    style,
    onSearchChange,
    onButtonClick,
    searchTerm,
    placeholder,
    showLoader = false,
    disabled = false,
}) => {

    const { theme } = useTheme();

    return (
        <div
            className={className}
            style={{
                width: '31%',
                height: '35px',
                backgroundColor: theme.colors.topBarsColorHover,
                border: `1px solid ${theme.colors.topBarsColorBorder}`,
                borderRadius: '5px',
                display: 'flex',
                alignItems: 'center',
                padding: '8px',
                ...style,
            }}
        >
            {/* <img src={SearchIcon} alt="" /> */}
            <SearchIcon size={14} color={theme.colors.topBarsColorText} />

            <input
                type="text"
                placeholder={ placeholder || "Search or type a command"}
                style={{
                    flex: 1,
                    border: 'none',
                    outline: 'none',
                    backgroundColor: 'transparent',
                    fontSize: '14px',
                    color: disabled ? theme.colors.topBarsColorText : theme.colors.topBarInputText,
                    fontWeight: 500,
                    fontFamily: 'Red Hat Display',
                    marginLeft: '10px',
                    cursor: disabled ? 'not-allowed' : 'text',
                }}
                value={searchTerm}
                disabled={disabled}
                onChange={(e) => onSearchChange?.(e.target.value)}
            />

            {showLoader && (
                <LoadingSpinner
                    size="sm"
                    style={{ width: '14px', height: '14px', color: theme.colors.topBarsColorText }}
                />
            )}

        </div>
    );
};

export default SearchBar;